import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {SecurityService} from '../../services/security.service'
@Component({
    selector: 'app-approve-dialog',
    templateUrl: './approve-dialog.component.html',
    styleUrls: ['./approve-dialog.component.scss'],
    standalone: false
})
export class ApproveDialogComponent implements OnInit {
  title="";
  message="";
 buttonOk;
  buttonCancel=false;
  constructor(
    public dialogRef: MatDialogRef<ApproveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      this.buttonCancel=false; 
     this.dialogRef.disableClose = true;
     this.title=data.title;
     this.message=data.message;
      this.buttonCancel=data.buttonCancel===false?data.buttonCancel:false;

    }

  close(): void {
    this.dialogRef.close("No");
  }
 
  ngOnInit(): void {
   // this.canActivate();
  }

  yes(){
    this.dialogRef.close("Yes");
  }
    
  no(){
    this.dialogRef.close("No");
  }
}
